import React from 'react';
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Paper
} from '@material-ui/core';
import strings from '../../../strings';

const SectionCard = ({ title, children }) => (
  <Paper
    elevation={1}
    style={{
      padding: 16,
      marginBottom: 16,
      borderRadius: 8,
      border: "1px solid #e3f2fd",
      backgroundColor: "var(--bg-canvas)",
    }}
  >
    <Typography variant="h6" style={{ fontWeight: 600, color: "var(--rox-lilac-ink)", marginBottom: 16 }}>
      {title}
    </Typography>
    {children}
  </Paper>
);

const ControlledSOSCriteriaForm = ({ value, onUpdatePolicy }) => {
  const handleToggle = (field, checked) => {
    if (onUpdatePolicy) {
      onUpdatePolicy(field, checked);
    }
  };

  return (
    <Box>
      <SectionCard title={strings.MARKETPLACE.SOS_CONFIGURATION}>
        <FormControlLabel
          label={strings.MARKETPLACE.EXCLUDE_INACTIVE_BUSINESSES}
          control={
            <Switch
              color="primary"
              checked={value?.excludeInactives || false}
              onChange={(e) => handleToggle('excludeInactives', e.target.checked)}
            />
          }
        />
        <Typography variant="caption" color="textSecondary" display="block" mb={2}>
          {strings.MARKETPLACE.EXCLUDE_INACTIVE_HELP}
        </Typography>

        <FormControlLabel
          label={strings.MARKETPLACE.EXCLUDE_UNKNOWN_STATUS}
          control={
            <Switch
              color="primary"
              checked={value?.excludeUnknown || false}
              onChange={(e) => handleToggle('excludeUnknown', e.target.checked)}
            />
          }
        />
        <Typography variant="caption" color="textSecondary" display="block">
          {strings.MARKETPLACE.EXCLUDE_UNKNOWN_HELP}
        </Typography>
      </SectionCard>
    </Box>
  );
};

export default ControlledSOSCriteriaForm;